import { useCarrierCargoListPageProps } from "./fetch";
import { CarrierCargoListPageUi } from "./ui";

export const CarrierCargoListPage = (params: {
  tab: "not_proposed" | "proposed" | undefined;
}) => {
  const props = useCarrierCargoListPageProps(params);
  return <CarrierCargoListPageUi {...props} />;
};
